// Shared route paths/names for client router + Express soft-404 matching.
module.exports = [
  { path: "/", name: "new-home" },
  { path: "/bankuserdashboard", name: "dashboard" },
  { path: "/blogs/:category?", name: "blogs-list" },
  { path: "/blog/:blogTitle/:blogId", name: "blog" },
  { path: "/blog-editor", name: "blog-editor" },
  { path: "/existing-blog-editor", name: "existing-blog-editor" },
  { path: "/existing-blogs", name: "ExistingBlogs" },
  { path: "/sample-reports", name: "ExploreOurSampleReports" },
  { path: "/credit-plan-assignment", name: "CreditPlanAssignment" },
  { path: "/credit-reconciliation", name: "CreditReconciliation" },
  { path: "/data-access-governance", name: "DataAccessGovernance" },
  { path: "/rewards", name: "CredenceConnectReferralProgram" },
  { path: "/search/:country?/:company?", name: "SearchForCompanies" },
  //  <!-- Commenting for now, will introduce new pages later on -->

  // { path: "/company-profile", name: "CompanyProfileList" },
  // {
  //   path: "/company-profile/:countryCode",
  //   name: "CompanyProfileListByCountry",
  // },
  // { path: "/company-profile/:country/:company", name: "CompanyProfile" },
  // { path: "/choose-package/:country?/:company", name: "ChoosePackage" },
  { path: "/payment/success", name: "OrderConfirmationModal" },
  { path: "/payment/no-success", name: "PaymentRetryModal" },
  { path: "/payment/retry", name: "PaymentRetry" },
  { path: "/payment/buy-credits-success", name: "BuyCreditSuccess" },
  { path: "/payment/buy-credits-no-success", name: "BuyCreditFailure" },
  { path: "/contact", name: "ShareYourThoughts" },
  { path: "/product", name: "ProductsPage" },
  { path: "/business-information-report", name: "BusinessInformationReport" },
  { path: "/global-company-search", name: "GlobalCompanySearch" },
  { path: "/trade-intelligence", name: "TradeIntelligence" },
  { path: "/trade-price-review", name: "TradePriceReview" },
  { path: "/api-services", name: "ApiServices" },
  { path: "/insight-lens", name: "InsightLens" },
  // { path: "/self-assessment", name: "SelfAssessment" },
  { path: "/learning", name: "CredenceLearning" },
  { path: "/aboutus", name: "AboutUs" },
  { path: "/profile", name: "YourProfile" },
  { path: "/banks-&-hq", name: "RM-Admin-portal" },
  { path: "/MyOrders", name: "Orders" },
  { path: "/MyOrders/:status", name: "AllOrders" },
  { path: "/price-verification", name: "PriceVerification" },
  { path: "/institutions", name: "Institutions" },
  { path: "/partnerships", name: "Partnerships" },
  { path: "/privacypolicy", name: "PrivacyPolicy" },
  { path: "/terms", name: "TermsAndConditions" },
  { path: "/order-details", name: "CreateOrder" },
  { path: "/manual-order", name: "CreateManualOrder" },
  { path: "/pi-order", name: "CompanySelection" },
  { path: "/rm-single-order", name: "CreateSingleOrder" },
  { path: "/whatsapp/termsandconditions", name: "termsandconditions" },
  { path: "/team-invite", name: "TeamInvite" },
  {
    path: "/replenish-credits/rm/:rm_id/user/:user_id/info/:info",
    name: "replenish-credits",
  },
  { path: "/digitalproduct/:company?/:country?", name: "Digitalproduct" },
  {
    path: "/digital-report/:company?/:country?/:orderid?",
    name: "DigitalReport",
  },
  { path: "/login", name: "Login" },
  { path: "/download-failure/:orderId?", name: "DownloadFailure" },
  { path: "/:catchAll(.*)", name: "notFound" },
];
